import { FC } from "react";

const LoadingView: FC = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="animate-spin rounded-full size-20 border-t-2 border-b-2 border-primary"></div>
    </div>
  );
};

export default LoadingView;
